module.exports = __webpack_public_path__ + "media/שור.77087ddb.mp3";